import { gql } from "lib/apolloClient";

export const fragments = {
  courseItem: gql`
    fragment courseItem on Course {
      id
      title
      sourcedId
      profileImage
      isArchived
      isMappedToMe
    }
  `,
  templateCourseItem: gql`
    fragment courseItem on Course {
      id
      title
      sourcedId
      profileImage
      isArchived
      isMappedToMe
    }
  `,
  postTemplate: gql`
    fragment postTemplate on PostTemplate {
      id
      state
      title
      type
      updatedBy {
        id
        firstName
        lastName
      }
      entityMap(filters: { entityTypes: [COURSE] }) {
        id
        entityType
        entity {
          id
          ...courseItem
        }
      }
      fields {
        id
        label
        placeholder
        displaySequence
        type
        dataSets {
          id
          title
          type
          startDate
          endDate
          values {
            id
            value
            date
            displaySequence
          }
        }
        metadata
      }
    }
  `,
};

export const courseListFragments = {
  organizationCourseList: gql`
    fragment organizationCourseItem on Organization {
      id
      courses(filters: $filters) {
        totalCount
        edges {
          node {
            ...courseItem
          }
        }
      }
    }
    ${fragments.courseItem}
  `,
};
